import statistic from './statistic'

export default {
  settings: {
    hasOvertime: true,
    hasGamerCondition: true
  },
  actionTypes: {
    score: ['PT1', 'PT2', 'PT3', 'CORRECTION_1_UP', 'CORRECTION_1_DOWN'],
    foul: ['FOUL']
  },
  modules: {
    info: [
      'timer',
      {
        type: 'periods',
        props: {
          className: 'liveCardPeriods__slider_left'
        }
      }
    ],
    score: {
      component: 'score-component'
    },
    fieldScheme: {
      component: 'match-center'
    },
    statistic,
    eventLog: true
  },
  storeScheme: {
    gamerCondition: {
      home: {
        eventCode: '',
        title: '...'
      },
      away: {
        eventCode: '',
        title: '...'
      }
    },
    score: {
      home: 0,
      away: 0
    },
    fouls: {
      home: 0,
      away: 0
    },
    getOvertimePeriodName: 'OT'
  }
}
